import { render, staticRenderFns } from "./xlibroTodos.vue?vue&type=template&id=ab05128c&scoped=true"
import script from "./xlibroTodos.vue?vue&type=script&lang=js"
export * from "./xlibroTodos.vue?vue&type=script&lang=js"
import style0 from "./xlibroTodos.vue?vue&type=style&index=0&id=ab05128c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab05128c",
  null
  
)

export default component.exports